import { useState, useEffect } from "react";
export function useFlagData(flagKey, fetcher, options = {}, helpers) {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!helpers) {
            setIsLoading(true);
            setData(null);
            setError(null);
            return;
        }
        let cancelled = false;
        const fetchFlagData = async () => {
            try {
                setIsLoading(true);
                setError(null);
                const result = await fetcher(flagKey, options);
                if (!cancelled) {
                    setData(result);
                    setIsLoading(false);
                }
            }
            catch (err) {
                if (!cancelled) {
                    setError(err instanceof Error ? err : new Error("Failed to fetch flag data"));
                    setData(null);
                    setIsLoading(false);
                }
            }
        };
        fetchFlagData();
        return () => {
            cancelled = true;
        };
    }, [helpers, flagKey, JSON.stringify(options)]);
    return {
        data,
        isLoading,
        error,
    };
}
